function o(o,r,c,d){o._m(r);var e=c("482d4d0c");o._(r,"PresetColors",e);}